module.exports = __webpack_public_path__ + "static/media/gal6.76088db7.jpg";